(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_estabelecimento-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const scriptEl = document.currentScript;

    // Procura o carrossel mais próximo: primeiro irmãos anteriores, depois ancestrais/DOM
    let host = scriptEl ? scriptEl.previousElementSibling : null;
    while (host && !host.matches('[data-est-carousel]')) {
      host = host.previousElementSibling;
    }
    if (!host) {
      host = scriptEl?.closest('[data-est-carousel]') || document.querySelector('[data-est-carousel]');
    }
    if (!host) return;

    const track = host.querySelector('[data-track]');
    const slides = Array.from(host.querySelectorAll('.est-media-slide'));
    const prev = host.querySelector('[data-prev]');
    const next = host.querySelector('[data-next]');
    const dots = Array.from(host.querySelectorAll('.est-media-dot'));

    // --- Swipe em mobile (touch) ---
    let touchStartX = null;
    let touchEndX = null;
    const SWIPE_THRESHOLD_PX = 40; // mínimo para considerar swipe

    const onTouchStart = (e) => {
      const t = e.changedTouches?.[0];
      if (!t) return;
      touchStartX = t.clientX;
      touchEndX = t.clientX;
    };

    const onTouchMove = (e) => {
      const t = e.changedTouches?.[0];
      if (!t) return;
      touchEndX = t.clientX;
      // (opcional) poderias animar o track aqui durante o arrasto
    };

    const onTouchEnd = () => {
      if (touchStartX == null || touchEndX == null) return;
      const deltaX = touchEndX - touchStartX;
      if (Math.abs(deltaX) > SWIPE_THRESHOLD_PX) {
        if (deltaX < 0) {
          // swipe para a esquerda -> próxima imagem
          setIndex(index + 1);
        } else {
          // swipe para a direita -> imagem anterior
          setIndex(index - 1);
        }
      }
      touchStartX = null;
      touchEndX = null;
    };

    const viewport = host.querySelector('.est-media-viewport');
    if (viewport) {
      viewport.addEventListener('touchstart', onTouchStart, { passive: true });
      viewport.addEventListener('touchmove', onTouchMove, { passive: true });
      viewport.addEventListener('touchend', onTouchEnd, { passive: true });
    }

    let index = 0;

    const setIndex = (i) => {
      if (!slides.length || !track) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = `translate3d(${-index * 100}%,0,0)`;
      dots.forEach((d, k) => d.classList.toggle('is-active', k === index));
    };

    prev && prev.addEventListener('click', () => setIndex(index - 1));
    next && next.addEventListener('click', () => setIndex(index + 1));
    dots.forEach((d) => d.addEventListener('click', (e) => setIndex(parseInt(e.currentTarget.dataset.dot || '0', 10))));

    // Altura responsiva (ocupa o máximo possível sem passar o viewport)
    const fitHeight = () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        const vp = host.querySelector('.est-media-viewport');
        if (!vp) return;
        let maxH = window.innerHeight;
        vp.style.setProperty('--est-media-max-h', Math.max(360, Math.min(900, maxH)) + 'px');
      } else {
        // Em mobile, não forçar altura nenhuma
        const vp = host.querySelector('.est-media-viewport');
        if (!vp) return;
        vp.style.removeProperty('--est-media-max-h');
      }
    };

    fitHeight();
    window.addEventListener('resize', fitHeight, { passive: true });

    // Inicial
    setIndex(0);
  })();
  } catch(e) { console.error(e); }
})();

})();
